import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import FAIcon from "../../UI/FAIcon/FAIcon";
import MessageToOpportunitiesModal from "../../Presentational/Message/MessageToOpportunitiesModal";
import ChangeStageModal from "../../Presentational/Stage/ChangeStageModal";
import BulkEditAssigneeModal from "../../Presentational/Opportunity/BulkEditAssigneeModal";
import CopyOpportunityModal from "../../Presentational/Opportunity/CopyOpportunityModal";
import EnrollOpportunitiesInCampaignModal from "../../Presentational/Campaign/EnrollOpportunitiesInCampaignModal";
import NoteToOpportunitiesModal from "../../Presentational/Note/NoteToOpportunitiesModal";
import TaskToOpportunitiesModal from "../../Presentational/Task/TaskToOpportunitiesModal";
import ActionPlanToOpportunitiesModal from "../../Presentational/Task/ActionPlanToOpportunitiesModal";
import SendSurveyToOpportunitiesModal from "../../Presentational/Survey/SendSurveyToOpportunitiesModal";
import useService from "../../Hooks/useService";
import VirtualizedAppService from "../../../Services/VirtualizedApp.service";
import PipelineService from "../../../Services/Pipeline.service";
import useHasVisibility from "../../Hooks/useHasVisibility";
import useHasPermission from "../../Hooks/useHasPermission";
import AlertToOpportunitiesModal from "../../Presentational/Alert/AlertToOpportunitiesModal";
export const MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL = 20;
const PipelineDetailListMenu = (props) => {
    var _a;
    const [messageModalOpen, setMessageModalOpen] = React.useState(false);
    const [noteModalOpen, setNoteModalOpen] = React.useState(false);
    const [alertModalOpen, setAlertModalOpen] = React.useState(false);
    const [isCreateTaskModalOpen, setIsCreateTaskModalOpen] = React.useState(false);
    const [isActionPlanModalOpen, setIsActionPlanModalOpen] = React.useState(false);
    const [isSendSurveyModalOpen, setIsSendSurveyModalOpen] = React.useState(false);
    const [isChangeStageModalOpen, setIsChangeStageModalOpen] = React.useState(false);
    const [isBulkEditAssigneeModalOpen, setIsBulkEditAssigneeModalOpen] = React.useState(false);
    const [isCopyOpportunityModalOpen, setIsCopyOpportunityModalOpen] = React.useState(false);
    const [isEnrollOpportunitiesInCampaignModalOpen, setIsEnrollOpportunitiesInCampaignModalOpen,] = React.useState(false);
    // Determine what bulk actions display
    // const personTypeContext = useContext(PersonTypeContext);
    const pipelinePersonTypeInternalNameArray = [
        props.pipeline.personType.internalName,
    ];
    const options = [];
    // Check for permission to edit opportunities in this pipeline
    // Determines if Change Stage and Change Assignee bulk actions appear
    const [canEditOpportunities, updateCanEditOpportunities] = useService(PipelineService.canCurrentUserEditOpportunities);
    React.useEffect(() => {
        updateCanEditOpportunities(props.pipeline.id);
    }, [props.pipeline.id, updateCanEditOpportunities]);
    if (canEditOpportunities.data) {
        options.push({
            id: 1,
            name: "Change Stage",
            icon: "arrows-h",
            title: "Change Stage",
        }, {
            id: 5,
            name: "Edit Assignee",
            icon: "user-edit",
            title: "Edit Assignee",
        });
    }
    // Check person type permissions for each bulk action
    const canBulkMessage = useHasVisibility("filterBulkMessage");
    if (canBulkMessage) {
        options.push({
            id: 2,
            name: "Message",
            icon: "envelope",
            title: "Create a Message",
        });
    }
    const canBulkNote = useHasVisibility("filterBulkNote");
    if (canBulkNote) {
        options.push({
            id: 3,
            name: "Note",
            icon: "sticky-note",
            title: "Create a Note",
        });
    }
    const canBulkTask = useHasVisibility("filterBulkTask");
    if (canBulkTask) {
        options.push({
            id: 4,
            name: "Task",
            icon: "tasks",
            title: "Create a Task",
        });
    }
    const canBulkActionPlan = useHasVisibility("filterBulkActionPlan");
    if (canBulkActionPlan) {
        options.push({
            id: 9,
            name: "Action Plan",
            icon: "clipboard-list",
            title: "Create an Action Plan",
        });
    }
    const canBulkSurvey = useHasVisibility("filterBulkSurvey");
    if (canBulkSurvey) {
        options.push({
            id: 7,
            name: "Survey",
            icon: "paper-plane",
            title: "Send a Survey",
        });
    }
    // Campaigns is special, need role permissions and page needs to be enabled in the app the pipeline is in
    const campaignsPermission = useHasPermission("CAN_ACCESS_CAMPAIGNS");
    const [campaignsTabEnabled, updateCampaignsTabEnabled] = useService(VirtualizedAppService.isPageAccessible);
    React.useEffect(() => {
        updateCampaignsTabEnabled("headerCampaigns");
    }, [updateCampaignsTabEnabled]);
    // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'boolean'.
    if (campaignsPermission && ((_a = campaignsTabEnabled.data) === null || _a === void 0 ? void 0 : _a.data)) {
        options.push({
            id: 6,
            name: "Campaign",
            icon: "megaphone",
            title: "Enroll in Campaign",
        });
    }
    const canAlert = useHasVisibility("filterBulkAlert");
    if (canAlert) {
        options.push({
            id: 10,
            name: "Alert",
            icon: "bell",
            title: "Create an Alert",
        });
    }
    // Always show copy opportunities. The modal should only show pipelines where it's possible for the current user to copy opportunities to.
    options.push({
        id: 8,
        name: "Copy Opportunity",
        icon: "copy",
        title: "Copy an Opportunity",
    });
    const handleModal = (id) => {
        switch (id) {
            case 1: {
                setIsChangeStageModalOpen(true);
                break;
            }
            case 2: {
                setMessageModalOpen(true);
                break;
            }
            case 3: {
                setNoteModalOpen(true);
                break;
            }
            case 4: {
                setIsCreateTaskModalOpen(true);
                break;
            }
            case 9: {
                setIsActionPlanModalOpen(true);
                break;
            }
            case 5: {
                setIsBulkEditAssigneeModalOpen(true);
                break;
            }
            case 6: {
                setIsEnrollOpportunitiesInCampaignModalOpen(true);
                break;
            }
            case 7: {
                setIsSendSurveyModalOpen(true);
                break;
            }
            case 8: {
                setIsCopyOpportunityModalOpen(true);
                break;
            }
            case 10: {
                setAlertModalOpen(true);
                break;
            }
            default:
                break;
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(ChangeStageModal, { opportunities: props.opportunities, isOpen: isChangeStageModalOpen, onModalClosed: () => {
                    setIsChangeStageModalOpen(false);
                    props.onCloseModal();
                }, pipelineId: props.pipeline.id }, 1), _jsx(MessageToOpportunitiesModal, { opportunities: props.opportunities, isOpen: messageModalOpen, onModalClosed: () => {
                    setMessageModalOpen(false);
                    props.onCloseModal();
                }, size: "lg" }, 3), _jsx(NoteToOpportunitiesModal, { opportunities: props.opportunities, pipelineId: props.pipeline.id, isOpen: noteModalOpen, onModalClosed: () => {
                    setNoteModalOpen(false);
                    props.onCloseModal();
                }, size: "lg", appendToBody: true }, 5), _jsx(AlertToOpportunitiesModal, { opportunities: props.opportunities, pipelineId: props.pipeline.id, isOpen: alertModalOpen, onModalClosed: () => {
                    setAlertModalOpen(false);
                    props.onCloseModal();
                }, size: "lg", appendToBody: true }, 18), _jsx(TaskToOpportunitiesModal, { opportunities: props.opportunities, pipelineId: props.pipeline.id, isOpen: isCreateTaskModalOpen, onModalClosed: () => {
                    setIsCreateTaskModalOpen(false);
                    props.onCloseModal();
                }, size: "lg" }, 7), _jsx(ActionPlanToOpportunitiesModal, { opportunities: props.opportunities, pipelineId: props.pipeline.id, isOpen: isActionPlanModalOpen, onModalClosed: () => {
                    setIsActionPlanModalOpen(false);
                    props.onCloseModal();
                }, size: "lg" }, 9), _jsx(BulkEditAssigneeModal, { opportunities: props.opportunities, isOpen: isBulkEditAssigneeModalOpen, onModalClosed: () => {
                    setIsBulkEditAssigneeModalOpen(false);
                    props.onCloseModal();
                }, pipelineId: props.pipeline.id }, 11), _jsx(EnrollOpportunitiesInCampaignModal, { opportunities: props.opportunities, isOpen: isEnrollOpportunitiesInCampaignModalOpen, onModalClosed: () => {
                    setIsEnrollOpportunitiesInCampaignModalOpen(false);
                    props.onCloseModal();
                } }, 13), _jsx(SendSurveyToOpportunitiesModal, { opportunities: props.opportunities, isOpen: isSendSurveyModalOpen, onModalClosed: () => {
                    setIsSendSurveyModalOpen(false);
                    props.onCloseModal();
                }, size: "lg", appendToBody: true }, 15), _jsx(CopyOpportunityModal, { pipelineId: props.pipeline.id, opportunities: props.opportunities, isOpen: isCopyOpportunityModalOpen, onModalClosed: () => {
                    setIsCopyOpportunityModalOpen(false);
                    props.onCloseModal();
                } }, 17), _jsxs("div", { className: "dropdown", children: [_jsx("button", { className: classNames("btn btn-link dropdown-toggle", props.className), "data-toggle": "dropdown", title: "Open menu", disabled: props.disabled, children: "Actions" }), _jsx("div", { className: "dropdown-menu shadow custom-scrollbar", style: { maxHeight: "220px", overflowY: "scroll" }, children: options.map((item) => {
                            return (_jsxs("button", { className: "dropdown-item btn btn-link text-dark", onClick: () => handleModal(item.id), title: item.title, children: [_jsx(FAIcon, { icon: item.icon, fixedWidth: true, addMarginRight: true }), item.name] }, item.id));
                        }) })] })] }));
};
export default PipelineDetailListMenu;
